module.exports = __webpack_public_path__ + "static/media/YM13_2.eb8183ca.jpg";